import styled from 'styled-components';

export const Container = styled.div`
  padding: 1.5rem 2rem;
  display: flex;
  background-color: ${({ theme }) => theme.colors.white4};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};

  & > div.details {
    width: 50%;

    & > div:not(:last-child) {
      padding-bottom: 1rem;
    }
  }

  & > div.values {
    width: 50%;

    & > div:not(:last-child) {
      padding-bottom: 1rem;
    }
  }
`;

export const Link = styled.a`
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  text-decoration-line: underline;
  color: ${(p) => p.theme.colors.blue6};
`;
